import React, { useRef } from 'react';
import { DocumentDuplicateIcon } from '@heroicons/react/24/outline';

export default function DuplicateButton({ onDuplicate }) {
  const firedRef = useRef(false);
  return (
    <button
      type="button"
      data-role="control-button duplicate-btn"
      onPointerDownCapture={(e) => {
        console.log('[DuplicateButton] onPointerDownCapture');
        e.preventDefault();
        e.stopPropagation();
        if (typeof window !== 'undefined') window.__sbwSuppressCanvasClick = true;
        if (!firedRef.current) {
          firedRef.current = true;
          onDuplicate?.();
        }
      }}
      onMouseDownCapture={(e) => {
        console.log('[DuplicateButton] onMouseDownCapture');
        e.preventDefault();
        e.stopPropagation();
        if (typeof window !== 'undefined') window.__sbwSuppressCanvasClick = true;
      }}
      onClickCapture={(e) => {
        console.log('[DuplicateButton] onClickCapture');
        e.preventDefault();
        e.stopPropagation();
        if (typeof window !== 'undefined') window.__sbwSuppressCanvasClick = true;
      }}
      onPointerDown={(e) => {
        console.log('[DuplicateButton] onPointerDown -> calling onDuplicate');
        e.preventDefault();
        e.stopPropagation();
        if (e.nativeEvent && typeof e.nativeEvent.stopImmediatePropagation === 'function') {
          e.nativeEvent.stopImmediatePropagation();
        }
        if (typeof window !== 'undefined') {
          window.__sbwSuppressCanvasClick = true;
        }
        if (!firedRef.current) {
          firedRef.current = true;
          onDuplicate?.();
        }
      }}
      onMouseDown={(e) => {
        console.log('[DuplicateButton] onMouseDown -> calling onDuplicate');
        e.preventDefault();
        e.stopPropagation();
        if (e.nativeEvent && typeof e.nativeEvent.stopImmediatePropagation === 'function') {
          e.nativeEvent.stopImmediatePropagation();
        }
        if (typeof window !== 'undefined') {
          window.__sbwSuppressCanvasClick = true;
        }
        // Trigger duplication on mousedown to avoid canvas deselect edge-cases
        if (!firedRef.current) {
          firedRef.current = true;
          onDuplicate?.();
        }
      }}
      onMouseUp={(e) => {
        console.log('[DuplicateButton] onMouseUp');
        e.preventDefault();
        e.stopPropagation();
        if (e.nativeEvent && typeof e.nativeEvent.stopImmediatePropagation === 'function') {
          e.nativeEvent.stopImmediatePropagation();
        }
        firedRef.current = false;
      }}
      onClick={(e) => {
        console.log('[DuplicateButton] onClick (suppressed)');
        // We already duplicated on mousedown; just suppress bubbling so
        // BaseElement/SpreadCanvas don't treat this as a selection click.
        e.preventDefault();
        e.stopPropagation();
        if (e.nativeEvent && typeof e.nativeEvent.stopImmediatePropagation === 'function') {
          e.nativeEvent.stopImmediatePropagation();
        }
        if (typeof window !== 'undefined') {
          window.__sbwSuppressCanvasClick = true;
        }
      }}
      style={{ zIndex: 1000, pointerEvents: 'auto' }}
      className="absolute top-9 right-0 translate-x-1/2 p-2 bg-white rounded-full shadow-lg ring-2 ring-indigo-500 hover:bg-white touch-manipulation"
      title="Duplicate element"
    >
      <DocumentDuplicateIcon className="h-5 w-5 text-gray-500 hover:text-indigo-500" />
    </button>
  );
}
